<mat-card appearance="outlined" class="calendar-card">
  <!-- Cabecera -->
  <mat-card-header class="calendar-header">
    <div class="header-content">
      <div class="title-section">
        <mat-card-title>
          <mat-icon class="title-icon">event</mat-icon>
          Agenda
        </mat-card-title>
        <mat-card-subtitle *ngIf="hasData">
          {{ dataSource.data.length }} evento{{ dataSource.data.length !== 1 ? 's' : '' }} registrado{{
          dataSource.data.length !== 1 ? 's' : '' }}
        </mat-card-subtitle>
      </div>

      <div class="actions-section">
        <mat-slide-toggle (change)="esEventosEmpresa($event)" color="primary">
          {{ checkedEsEventosEmpresa ? 'Eventos personal' : 'Eventos empresa' }}
        </mat-slide-toggle>
        <mat-slide-toggle (change)="vistaTabla($event)" color="primary">
          {{ checkedEsVistaTabla ? 'Vista tabla' : 'Vista gráfico' }}
        </mat-slide-toggle>
        <mat-slide-toggle (change)="checkfiltros($event)" color="primary">
          Filtros
        </mat-slide-toggle>
        <!-- Botón de actualizar -->
        <button mat-icon-button (click)=" aplicarFiltro()" [disabled]="loading" matTooltip="Actualizar eventos"
          matTooltipPosition="below">
          <mat-icon [class.spinning]="loading">refresh</mat-icon>
        </button>

        <!-- Botón nuevo evento -->
        <button mat-raised-button [matMenuTriggerFor]="menuNuevo" color="primary" [disabled]="loading">
          <mat-icon>add</mat-icon>
          Nuevo Evento
        </button>

        <!-- Menú de opciones -->
        <mat-menu #menuNuevo="matMenu" class="custom-menu">
          <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Agregar, tipoEvento: tiposEventos.Evento})"
            color="primary">
            <mat-icon color="primary">event</mat-icon>
            <span>Evento Genérico</span>
          </button>
          <button mat-menu-item
            (click)="openDialog({ accion: accionesDialog.Agregar, tipoEvento: tiposEventos.Audiencia})">
            <mat-icon color="primary">gavel</mat-icon>
            <span>Audiencia</span>
          </button>
          <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Agregar, tipoEvento: tiposEventos.Prueba})"
            color="primary">
            <mat-icon color="primary">science</mat-icon>
            <span>Prueba</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-card-header>

  <!-- Contenido principal -->
  <mat-card-content class="calendar-content">


    <!-- Contenido de filtros -->
    <mat-card-content *ngIf="checkedFiltro">
      <form [formGroup]="formFilter">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Título del evento</mat-label>
              <input matInput formControlName="Titulo" placeholder="Nombre descriptivo del evento">
              <mat-icon matSuffix>title</mat-icon>
              <mat-hint>Máximo 255 caracteres</mat-hint>
              <mat-error *ngIf="formFilter.get('Titulo')?.hasError('required')">
                El título es requerido
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col" *ngIf="checkedFiltroAvanzado">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Rango de Fechas de Alta</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
                <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>Tipo de evento</mat-label>
              <mat-select multiple formControlName="IdsTipoEvento">
                <mat-option *ngFor="let tipo of listaTiposEvento;trackBy: trackByFn" [value]="tipo.id">
                  {{ tipo.descripcion }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>category</mat-icon>
              <mat-error *ngIf="formFilter.get('IdsTipoEvento')?.hasError('required')">
                Seleccione un tipo
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>Estado</mat-label>
              <mat-select multiple formControlName="IdsEstadoEvento">
                <mat-option *ngFor="let estado of estadosEventoAgenda;trackBy: trackByFn" [value]="estado.id">
                  <mat-icon>{{ getStatusIcon(estado.descripcion) }}</mat-icon>
                  {{ estado.descripcion }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>flag</mat-icon>
              <mat-error *ngIf="formFilter.get('IdsEstadoEvento')?.hasError('required')">
                Seleccione un estado
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-auto">
            <div style="display: flex; align-items: center; gap: 8px;">
              <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
              <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
            </div>
          </div>
          <div class="col-auto">

            <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
              Filtros Avanzados
            </mat-slide-toggle>
          </div>
        </div>
      </form>
    </mat-card-content>

    <!-- Spinner de carga -->
    <ngx-spinner [zIndex]="100" name="spLoadCalendar" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Mensaje de error -->
    <mat-card class="error-card" *ngIf="error && !loading" appearance="outlined">
      <mat-card-content>
        <div class="error-content">
          <mat-icon color="warn" class="error-icon">error_outline</mat-icon>
          <div class="error-text">
            <h3>Error al cargar eventos</h3>
            <p>{{ error }}</p>
            <button mat-stroked-button color="primary" (click)="loadEventos()">
              <mat-icon>refresh</mat-icon>
              Reintentar
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Componente sin datos -->
    <app-sin-datos-para-mostrar [dataSource]="dataSource" *ngIf="!hasData && !loading && !error">
    </app-sin-datos-para-mostrar>

    <!-- Contenedor del calendario -->
    <div class="calendar-container" *ngIf="hasData && !error">

      <!-- Calendario -->
      <div class="calendar-wrapper" *ngIf="!checkedEsVistaTabla">
        <full-calendar #calendarRef *ngIf="!loading" [options]="calendarOptions" class="custom-calendar">
        </full-calendar>
      </div>

      <!-- Tabla de eventos (opcional) -->
      <div class="table-wrapper" *ngIf="checkedEsVistaTabla">

        <!-- Inicio Contenedor acciones tabla -->
        <div class="contenedor-acciones-tablas">
          <div class="acciones-tabla">
            <!-- Boton de Acciones -->
            <app-button-action *ngIf="selection.selected.length > 0"></app-button-action>
          </div>
          <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
          </mat-form-field>
        </div>
        <!-- Fin Contenedor acciones tabla -->

        <div *ngIf="data">
          <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">

            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleRow(row)"
                  [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>

            <!-- Título -->
            <ng-container matColumnDef="titulo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
              <td mat-cell *matCellDef="let evento">
                <span [matTooltip]="evento.titulo" matTooltipPosition="above">
                  {{ evento.titulo.length > 40 ? (evento.titulo | slice:0:50) + '...' : evento.titulo }}
                </span>
              </td>
            </ng-container>

            <!-- Fecha Inicio -->
            <ng-container matColumnDef="fechaInicio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Inicio</th>
              <td mat-cell *matCellDef="let evento">
                <div>
                  <div>{{ evento.fechaInicio | date: 'dd/MM/yyyy' }}</div>
                  <div class="hora-texto">{{ evento.horaInicio }}</div>
                </div>
              </td>
            </ng-container>

            <!-- Fecha Fin -->
            <ng-container matColumnDef="fechaFin">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Fin</th>
              <td mat-cell *matCellDef="let evento">
                <div>
                  <div>{{ evento.fechaFin | date: 'dd/MM/yyyy' }}</div>
                  <div class="hora-texto">{{ evento.horaFin }}</div>
                </div>
              </td>
            </ng-container>

            <!-- Tipo -->
            <ng-container matColumnDef="tipoEventoAgenda">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let evento">
                <mat-chip [style.background-color]="getColorPorDescripcion(evento.tipoEventoAgenda?.descripcion)">
                  {{ evento.tipoEventoAgenda?.descripcion }}
                </mat-chip>
              </td>
            </ng-container>

            <!-- Estado -->
            <ng-container matColumnDef="estadoEventoAgenda">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let evento">
                <mat-chip [color]="getChipColorByState(evento.estadoEventoAgenda?.descripcion)">
                  {{ evento.estadoEventoAgenda?.descripcion }}
                </mat-chip>
              </td>
            </ng-container>

            <ng-container matColumnDef="estados">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let evento">
                <mat-icon class="icon-hover" matTooltip="Es todo el día." *ngIf="evento.esTodoElDia">schedule</mat-icon>
                <mat-icon class="icon-hover" matTooltip="Es recurrente." *ngIf="evento.esRecurrente">repeat</mat-icon>
                <mat-icon class="icon-hover" matTooltip="Es evento presencial."
                  *ngIf="evento.esEventoPresencial">place</mat-icon>
                <mat-icon class="icon-hover" [matTooltip]="'Aviso '+evento.avisoNMinutosAntes +  ' min antes.'"
                  *ngIf="evento.avisoNMinutosAntes && evento.avisoNMinutosAntes > 0">{{
                  getReminderIcon(evento.avisoNMinutosAntes) }}</mat-icon>
              </td>
            </ng-container>

            <!-- Acción -->
            <ng-container matColumnDef="accion">
              <th mat-header-cell *matHeaderCellDef><strong>Acción</strong></th>
              <td mat-cell *matCellDef="let item" class="action-link">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: item })"
                    *appRoles="['Usuarios.Ver']">
                    <mat-icon>visibility</mat-icon>
                    <span>Ver</span>
                  </button>

                  <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: item })"
                    *appRoles="['Usuarios.Modificar']">
                    <mat-icon>edit</mat-icon>
                    <span>Editar</span>
                  </button>

                  <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: item })"
                    *appRoles="['Usuarios.Eliminar']">
                    <mat-icon>delete</mat-icon>
                    <span>Eliminar</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Definición de filas -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
            [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
          </mat-paginator>
        </div>


      </div>

    </div>
  </mat-card-content>
</mat-card>
